module.exports = __webpack_public_path__ + "static/messenger-forward-bubbles-b25a18cf57d3bde2f2a28226f5eeaf2f.jpg";